import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  firstname: "",
  lastname: "",
  email: "",
  password: "",
  accountname: "",
  currentnumber: "",
  newnumber: "",
  street: "",
  city: "",
  region: "",
  postalcode: "",
  isocountry: "",
  plan: {},
  card: {},
  newnumbersoptions: [],
  clickedSelect: false,
  showDetailForm: false,
};

export const RegisterSlice = createSlice({
  name: "register",
  initialState,
  reducers: {
    form1: (state, action) => {
      state.firstname = action.payload.firstname;
      state.lastname = action.payload.lastname;
      state.email = action.payload.email;
      state.password = action.payload.password;
    },
    form2: (state, action) => {
      state.accountname = action.payload.accountname;
      state.currentnumber = action.payload.currentnumber;
      state.newnumber = action.payload.newnumber;
      state.street = action.payload.street;
      state.city = action.payload.city;
      state.isocountry = action.payload.isocountry;
      state.postalcode = action.payload.postalcode;
      state.region = action.payload.region;
    },
    addPlan: (state, action) => {
      state.plan = action.payload;
    },
    addCard: (state, action) => {
      state.card = action.payload;
    },
    addnewnumberoptions: (state, action) => {
      state.newnumbersoptions = action.payload;
    },
    clickedSelectHandler: (state) => {
      state.clickedSelect = true;
      state.showDetailForm = false;
    },
    showDetailFormHandler: (state) => {
      state.clickedSelect = false;
      state.showDetailForm = true;
    },
  },
});

export default RegisterSlice;
